/**
 * True when the admin has toggled an existing company's Software As Service
 * setting away from the value it loaded with. Drives the cascade warning.
 *
 * `editing` gates out /companies/new, where software_as_service is absent
 * from initialValues entirely (manage-company.jsx:110-161) and the cascade
 * would be vacuous anyway.
 *
 * The `!!` normalization matters: in edit mode software_as_service reaches
 * initialValues only through the ...companyProfile spread, so it may be
 * null or absent. Without it, two clicks leave values at false against an
 * initial undefined and a bare !== fires on a net-zero change.
 */
export const saasSettingChanged = (editing, values, initialValues) =>
  !!editing &&
  !!(values && values.software_as_service) !==
    !!(initialValues && initialValues.software_as_service);
